import React from "react";
import { Box } from "@mui/material";

const Links = () => {
  const handleScroll = (sectionId) => {
    const section = document.getElementById(sectionId);
    if (section) {
      const offsetTop = section.getBoundingClientRect().top + window.scrollY;
      const offset = 100; // Adjust this value as needed for your sticky menu height
      window.scrollTo({ top: offsetTop - offset, behavior: "smooth" });
    }
  };

  const alwaysLinks = [];

  return (
    <Box
      sx={{
        flexGrow: 1,
        display: { xs: "none", md: "none", lg: "flex" },
        marginLeft: "20px",
        marginTop: "17px",
      }}
    >
      {/* Always visible links */}
      {alwaysLinks.map((myItem, index) => (
        <Box
          key={"linksnav" + index}
          onClick={() => handleScroll(myItem.to)}
          sx={{ cursor: "pointer", marginRight: "20px" }}
        >
          {myItem.children}
        </Box>
      ))}
    </Box>
  );
};

export default Links;
